import React, {useState} from "react";
import PropTypes from "prop-types";
import {styled} from "@mui/material/styles";
import {Slider} from "@mui/material";
import AvatarEditor from "react-avatar-editor";

import LoadingButton from "@mui/lab/LoadingButton";

const RESULT_IMAGE_SIZE = 800;

export default function ImageEditor({image, borderRadius, onClose, onSave}) {
    const [scale, setScale] = useState(1);
    const [rotate, setRotate] = useState(0);

    const editorRef = React.useRef();

    return (
        <Container>
            <AvatarEditorContainer>
                <AvatarEditor
                    ref={(ref) => editorRef.current = ref}
                    style={{
                        display: "block",
                        margin: "0 auto",
                        maxWidth: "100%",
                        height: "auto"
                    }}
                    image={image}
                    width={RESULT_IMAGE_SIZE}
                    height={RESULT_IMAGE_SIZE}
                    border={[150, 50]}
                    borderRadius={borderRadius}
                    color={[236, 237, 241, 0.9]}
                    rotate={rotate}
                    scale={scale}
                />

                <Rotate onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setRotate(rotate + 90);
                }}>
                    <RotateIcon
                        fill="#000000"
                        version="1.1"
                        id="Capa_1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        width="800px"
                        height="800px"
                        viewBox="0 0 509.823 509.822"
                        xmlSpace="preserve"
                    >
                        <g>
                            <path
                                d="M509.823,254.911c0,140.559-114.354,254.911-254.911,254.911C114.353,509.822,0,395.47,0,254.911h44.97
                                c0,115.758,94.182,209.949,209.942,209.949c115.757,0,209.938-94.191,209.938-209.949c0-115.76-94.182-209.941-209.938-209.941
                                c-50.893,0-99.505,18.291-137.719,51.558l45.908,45.903L20.507,165.208L43.283,22.633l42.057,42.05
                                C132.097,22.972,192.071,0,254.912,0C395.469,0,509.823,114.353,509.823,254.911z M409.653,251.164L255.002,96.513L100.347,251.164
                                l154.655,154.652L409.653,251.164z"
                            />
                        </g>
                    </RotateIcon>
                </Rotate>
            </AvatarEditorContainer>

            <SliderContainer>
                <Slider
                    min={1}
                    max={5}
                    step={0.1}
                    value={scale}
                    onChange={(event, value) => {
                        setScale(value);
                    }}
                />
            </SliderContainer>

            <ButtonsContainer>
                <LoadingButton
                    variant="cancel"
                    type="buttom"
                    size="medium"
                    onClick={() => {
                        onClose();
                    }}
                >
                    Cancel
                </LoadingButton>

                <LoadingButton
                    variant="contained"
                    type="buttom"
                    size="medium"
                    onClick={() => {
                        editorRef.current?.getImageScaledToCanvas().toBlob((blob) => {
                            const file = new File([blob], "Profile");
                            onSave(file);
                        });
                    }}
                >
                    Confirm
                </LoadingButton>
            </ButtonsContainer>
        </Container>
    );
}

ImageEditor.propTypes = {
    children: PropTypes.string,
};

const Container = styled('div')({
    borderRadius: '25px',
    minWidth: '380px',

    '@media (max-width: 500px)': {
        minWidth: 'auto',
        minHeight: 'auto',
    },
});

const AvatarEditorContainer = styled('div')({
    position: 'relative',
});

const SliderContainer = styled('div')({
    margin: '10px',
});

const Rotate = styled('div')({
    position: 'absolute',
    bottom: '10px',
    right: '10px',
    fontSize: '25px',
    zIndex: 10,
    cursor: 'pointer',
    lineHeight: '13px',
    padding: '4px',
    backgroundColor: '#fff',
    borderRadius: '5px',
});

const RotateIcon = styled('svg')({
    width: '20px',
    height: '20px',
});

const ButtonsContainer = styled('div')({
    paddingTop: '10px',
    paddingBottom: '10px',
    display: 'flex',
    gap: '10px',

    '& > button': {
        minWidth: 'auto',
        display: 'flex',
        flex: 1,
    },
});
